export enum ServiceStates {
  INITIAL,
  SENDING,
  SENT,
  ERROR,
}
